import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const showroomListRequest = createAction(types.SHOWROOM_LIST_REQUEST);
export const showroomListSuccess = createAction(types.SHOWROOM_LIST_SUCCESS);
export const showroomListFailure = createAction(types.SHOWROOM_LIST_FAILURE);

export const recentDealListRequest = createAction(
  types.RECENT_DEAL_LIST_REQUEST,
);
export const recentDealListSuccess = createAction(
  types.RECENT_DEAL_LIST_SUCCESS,
);
export const recentDealListFailure = createAction(
  types.RECENT_DEAL_LIST_FAILURE,
);

export const allDealsRequest = createAction(types.ALL_DEALS_REQUEST);
export const allDealsSuccess = createAction(types.ALL_DEALS_SUCCESS);
export const allDealsFailure = createAction(types.ALL_DEALS_FAILURE);

export const dealRequest = createAction(types.DEAL_REQUEST);
export const dealSuccess = createAction(types.DEAL_SUCCESS);
export const dealFailure = createAction(types.DEAL_FAILURE);

export const dealUpdateSuccess = createAction(types.DEAL_UPDATE_SUCCESS);
export const dealUpdateFailure = createAction(types.DEAL_UPDATE_FAILURE);

export const setDealTradeIns = createAction(types.SET_DEAL_TRADEINS);

export const dealTradeInsUpdateSuccess = createAction(
  types.DEAL_TRADEINS_UPDATE_SUCCESS,
);
export const dealTradeInsUpdateFailure = createAction(
  types.DEAL_TRADEINS_UPDATE_FAILURE,
);

export const dealCreateRequest = createAction(types.DEAL_CREATE_REQUEST);
export const dealCreateSuccess = createAction(types.DEAL_CREATE_SUCCESS);
export const dealCreateFailure = createAction(types.DEAL_CREATE_FAILURE);

export const onlineDealCreateRequest = createAction(
  types.ONLINE_DEAL_CREATE_REQUEST,
);
export const onlineDealCreateSuccess = createAction(
  types.ONLINE_DEAL_CREATE_SUCCESS,
);
export const onlineDealCreateFailure = createAction(
  types.ONLINE_DEAL_CREATE_FAILURE,
);

export const dealerRequest = createAction(types.DEALER_REQUEST);
export const dealerSuccess = createAction(types.DEALER_SUCCESS);
export const dealerFailure = createAction(types.DEALER_FAILURE);

export const paymentsRequest = createAction(types.PAYMENTS_REQUEST);
export const paymentsSuccess = createAction(types.PAYMENTS_SUCCESS);
export const paymentsFailure = createAction(types.PAYMENTS_FAILURE);
export const paymentsReset = createAction(types.PAYMENTS_RESET);

export const loadDealData = createAction(types.LOAD_DEAL_DATA_REQUEST);
export default {
  showroomListRequest,
  showroomListSuccess,
  showroomListFailure,
  recentDealListRequest,
  recentDealListSuccess,
  recentDealListFailure,
  allDealsRequest,
  allDealsSuccess,
  allDealsFailure,
  dealRequest,
  dealSuccess,
  dealFailure,
  dealerRequest,
  dealerSuccess,
  dealerFailure,
  paymentsRequest,
  paymentsSuccess,
  paymentsFailure,
  paymentsReset,
  dealUpdateSuccess,
  dealUpdateFailure,
  setDealTradeIns,
  dealTradeInsUpdateFailure,
  dealCreateRequest,
  dealCreateSuccess,
  dealCreateFailure,
  loadDealData,
};
